import {inject} from 'aurelia-framework';  
import { HttpClient } from 'aurelia-http-client';

export class WebRtcAPI {


    constructor(){
        
    }
   
    saveVideo(portrait,file, capture_key, upload = false,video_id,video_email = false, video_message = false,progressCallback, successCallback, errorCallback, is_branded_video = false) {



        // console.log("window size", window.innerHeight, window.innerWidth);
        // if (ua.indexOf("ipad") != -1 || ua.indexOf("iphone") != -1 || ua.indexOf("ipod") != -1) {
        //         console.log("portait iphone true");
        //     if(window.innerHeight > window.innerWidth) {
        //         this.portrait = true;
        //     }
        //  }   
        // console.log("portrait", this.portrait);

        // localStorage.setItem("portrait",this.portrait);
        var formData = new FormData();

        // let iphoneCheck1 = localStorage.getItem("portrait");
        // let iphoneCheck2 = false;
        // // let iphoneCheck2 = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
        // let ios = iphoneCheck1 || iphoneCheck2;
        // console.log("ios check",iphoneCheck1,portrait);

        formData.append('capture_key', capture_key);
        formData.append('upload', upload);
        formData.append('video_id', video_id);
        formData.append('video_email', video_email);
        formData.append('testimonial', file);
        formData.append('iphone_video', portrait);
        formData.append('is_branded_video', is_branded_video);
        //Here we need to append branded video type and its id
        formData.append('video_message', video_message);

        // localStorage.removeItem("portrait");
        // for (var pair of formData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]+ ', ' + pair[2]+ ',',pair[3]+ ', ' + pair[4]); 
        // }
        var http = new HttpClient().configure(config => {
            config.withProgressCallback(progressCallback);
        });
        
        http.post('api/webrtc/saveVideo', formData)
            .then(data => {

                if (data.isSuccess) {

                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("filename"))
                        successCallback(json);

                }
                else {
                    errorCallback(data.statusText);
                }
            }).catch((reason) => {
                errorCallback("Unexpected error uploading video!", reason);
            });



    }

   

}